import cx from 'classnames'
import { TABS, TabKey } from './tabs'
import styles from './TabBar.module.css'

/** 시안 `nav.doms` / `.dtab` 이식. 상단 탭 6개. */
export type TabBarProps = {
  tab: TabKey
  onChange: (key: TabKey) => void
  /**
   * LOGISPRD-13034 — 재발사 응답을 기다리는 동안 탭 전환 자체를 막는다(`FoptTab` 의 `onBusyChange`
   * 참고). 잠겨 있어도 현재 탭 표시(`.active`)는 그대로다 — 잠금이 "어디 있는지"까지 지우면 안 된다.
   * `hash` 로 탭을 바꾸는 경로(뒤로/앞으로가기)는 이 prop 과 무관하게 계속 열려 있다 — 이번 범위 밖.
   */
  locked?: boolean
}

export const TabBar = ({ tab, onChange, locked = false }: TabBarProps): JSX.Element => (
  <nav className={styles.doms}>
    {TABS.map((t) => (
      <button
        key={t.key}
        type="button"
        className={cx(styles.dtab, tab === t.key && styles.active)}
        aria-current={tab === t.key || undefined}
        disabled={locked}
        title={locked ? '재발사 응답을 기다리는 중이라 탭을 바꿀 수 없어요' : undefined}
        aria-label={locked ? `${t.label} — 재발사 응답을 기다리는 중이라 탭을 바꿀 수 없어요` : undefined}
        onClick={() => onChange(t.key)}
      >
        {t.label}
      </button>
    ))}
  </nav>
)
